// removed by extract-text-webpack-plugin
module.exports = {"newsletter":"c-RegisterCustomerClubFields__newsletter"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/RegisterCustomerClubFields/RegisterCustomerClubFields.scss
// module id = 1119
// module chunks = 0